import React, { useEffect, useState } from 'react'
import useSearchQuery from 'hooks/useSearchQuery'
import { useNavigate } from 'react-router-dom'
import { Flex, Icon, IconButton } from '@chakra-ui/react'
import InfoElement from 'screens/Comments/InfoElement/InfoElement'
import { TabNavigation } from '../../../components/UI/TabNavigation'
import { SECTIONS_TABS } from 'constants/sections'
import ListPanel from '../OldSections'
import NewSections from '../NewSections'
import ReleasesAndSales from '../ReleasesAndSales'
import { FaMinus, FaPlus } from 'react-icons/fa'

const SectionsLayout = () => {
  const { active, create, manage } = useSearchQuery()
  const navigate = useNavigate()
  const [showButtons, setShowButtons] = useState(true)

  const toggleButtons = () => {
    setShowButtons(!showButtons)
  }

  const isContentCreation = create === 'yes'
  const isManageContent = manage === 'yes'

  const isContentWorker = isContentCreation || isManageContent

  const isOldLists = active === SECTIONS_TABS.lists.query
  const isNewSections = active === SECTIONS_TABS.sections.query

  const isReleasesAndSales =
    active === SECTIONS_TABS['new-releases-and-sales'].query

  useEffect(() => {
    if (!Object.keys(SECTIONS_TABS).includes(active)) {
      navigate('/sections')
    }
  }, [active, navigate])

  return (
    <Flex
      w='100%'
      h='100%'
      bg='linear-gradient(135deg, #F3F1FF 0%, #F0FBFF 100%)'
      position='relative'
      direction='column'
      overflow='hidden'
    >
      <Flex
        mt='8px'
        direction='column'
        pr='34px'
        gap='12px'
        h='100%'
        w='100%'
        overflow='hidden'
      >
        {!isContentWorker && (
          <Flex w='100%' position='relative' minH='50px'>
            {showButtons && (
              <TabNavigation
                buttons={Object.entries(SECTIONS_TABS)}
                active={active || ''}
              />
            )}

            <IconButton
              icon={<Icon as={showButtons ? FaMinus : FaPlus} color='white' />}
              aria-label={showButtons ? 'Hide navigation' : 'Show navigation'}
              onClick={toggleButtons}
              position='absolute'
              right='0'
              top='50%'
              transform='translateY(-50%)'
              ml='16px'
              bg={showButtons ? 'purple.500' : 'teal.500'}
              color='white'
              _hover={{
                bg: showButtons ? 'purple.600' : 'teal.600',
                color: 'white',
              }}
              borderRadius='md'
              boxShadow='md'
              size='lg'
            />
          </Flex>
        )}

        {!active && (
          <InfoElement
            title='Please, select the tab you need'
            image='/images/hero/denied.png'
          />
        )}

        {isOldLists && <ListPanel />}

        {isNewSections && <NewSections />}

        {isReleasesAndSales && <ReleasesAndSales showButtons={showButtons} />}
      </Flex>
    </Flex>
  )
}

export default SectionsLayout
